// Quiz module
var $ = require('jquery');
module.exports = {
    template: require('./template.html'),
    replace: false,
    data: function () {
        return {

        };
    },
    computed: {

    },
    methods: {

        shareSiteFb: function () {

            shareSite();

        },

        shareLinkedInLn: function () {

            shareLinkedInSite();

        },

        thejobclick: function () {

            ga('send', 'event', 'About', 'click', 'About');

            $('.socialQuiz').toggleClass('active');
            $('.btn').toggleClass('active');
            $('.formwrap').toggleClass('active');
            $('.animateQuiz').toggleClass('active');
            $('.closeopen').toggleClass('active');
            $('.aboutWrapper').toggleClass('active');
            $('.overlay').toggleClass('active');
            $('.startText').toggleClass('active');
            $('.quiztext').toggleClass('active');
            $('.aboutskew').toggleClass('active');
            $('.badgewrapper').toggleClass('active');
            $('.wave').toggleClass('active');
            $('.socialStart').toggleClass('active');
            $('.form').toggleClass('active');
            $('.aboutInnerWrap').toggleClass('active');


        },

        tweetShareStart: function () {

            ga('send', 'event', 'Share', 'click', 'Twitter Site');

            var loc = $(this).attr('href');
            var title  = encodeURIComponent('We are looking for passionate musicologists to join our team creating next-level programmed music experiences. Apply now! #TheJobByFiltr');
            window.open('http://twitter.com/share?url=' + loc + '&text=' + title + '&', 'twitterwindow', 'height=450, width=550, top='+($(window).height()/2 - 225) +', left='+$(window).width()/2 +', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
        }

    },
    ready: function () {

    },
    route: {

    }
}


